export default __webpack_public_path__ + "static/mobile_6-c2b7b65f2e4385a6f560ddfe83f5ed78.webp";